import { graphql } from "../graphql";
import mutation from "./mutation.gql";
import { RepoErrorEnum } from "../repo-error.enum";

export async function updatePublishBusiness(
  businessId: string
): Promise<boolean> {
  try {
    const response = await graphql.mutate({
      mutation,
      variables: {
        businessId,
      },
    });

    return response.data.publishBusiness;
  } catch {
    throw new Error(RepoErrorEnum.NETWORK_ERROR);
  }
}
